// frontend/src/components/Seo/Seo.tsx
import React from "react";
import { Helmet } from "react-helmet";

export interface SeoProps {
  title: string;
  description: string;
  name?: string; // sometimes used for “og:site_name”
  type?: string; // e.g. “website” or “article”
  image?: string; // for OpenGraph / Twitter Card
  keywords?: string;
}

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  name,
  type = "website",
  image,
  keywords,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {/* OpenGraph tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {name && <meta property="og:site_name" content={name} />}
      {/* Twitter Card */}
      <meta
        name="twitter:card"
        content={image ? "summary_large_image" : "summary"}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
};

export default Seo;
